var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttestation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 429,
    viewBox: "0 0 478 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.602 352.356C469.239 379.203 449.579 399.992 428.649 418.16C425.727 420.697 422.798 423.184 419.863 425.622C419.842 425.634 419.822 425.657 419.801 425.67C419.661 425.786 419.519 425.904 419.387 426.019L417.574 427.521L417.951 427.639L419.126 428.001L417.921 427.673C417.801 427.639 417.676 427.611 417.557 427.576C403.681 423.828 389.521 419.714 378.177 410.933C366.408 401.812 358.302 386.263 362.362 371.938C362.896 370.06 363.638 368.249 364.574 366.536C364.956 365.82 365.378 365.126 365.822 364.443C368.504 360.23 372.26 356.807 376.703 354.527C381.147 352.246 386.117 351.191 391.104 351.468C396.09 351.745 400.913 353.346 405.076 356.105C409.239 358.864 412.592 362.682 414.79 367.167C414.593 351.382 400.174 339.871 386.651 331.724C373.122 323.583 357.804 314.787 353.552 299.577C351.18 291.114 353.175 282.398 357.831 275.034C357.976 274.81 358.121 274.586 358.27 274.367C363.981 265.755 372.73 259.615 382.771 257.172C401.504 252.922 421.139 260.749 436.505 272.284C461.237 290.842 478.562 321.829 473.601 352.355L473.602 352.356Z",
    fill: "#F2F2F2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.02 322.599C438.338 327.822 441.87 333.647 444.507 339.89C446.774 345.481 448.193 351.379 448.716 357.39C449.853 369.734 447.511 382.214 442.841 393.64C439.207 402.314 434.492 410.494 428.807 417.985C425.908 420.503 422.981 422.989 420.026 425.442C420.006 425.454 419.986 425.477 419.966 425.489C419.825 425.605 419.683 425.723 419.553 425.839L417.74 427.339L418.117 427.457L419.292 427.818C418.888 427.708 418.49 427.602 418.087 427.491C417.967 427.457 417.843 427.429 417.722 427.395C417.741 417.534 415.395 407.813 410.883 399.046C406.37 390.279 399.822 382.721 391.787 377.005C383.746 371.393 374.493 367.76 364.782 366.403C365.163 365.686 365.585 364.994 366.029 364.311C369.787 364.893 373.485 365.808 377.083 367.042C389.936 371.418 401.038 379.816 408.747 390.994C415.679 401.151 419.57 413.075 419.962 425.367C420.447 424.808 420.93 424.24 421.398 423.679C430.322 413.102 437.956 401.275 442.506 388.138C446.485 376.998 447.663 365.05 445.937 353.348C443.906 340.605 437.381 329.361 428.756 319.924C419.518 309.826 408.426 301.243 396.818 294.047C384.926 286.662 372.175 280.759 358.849 276.472C358.549 276.373 358.297 276.162 358.148 275.883C357.998 275.605 357.961 275.279 358.044 274.974C358.097 274.703 358.255 274.463 358.483 274.307C358.602 274.238 358.735 274.197 358.872 274.186C359.009 274.176 359.147 274.196 359.275 274.247C360.921 274.775 362.556 275.317 364.184 275.891C377.736 280.678 390.641 287.129 402.603 295.097C414.154 302.773 425.245 311.794 434.02 322.599Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.018 261.75C197.687 261.748 196.407 261.24 195.436 260.329C194.465 259.419 193.877 258.173 193.79 256.845L193.011 244.955C192.966 244.267 193.056 243.577 193.278 242.924C193.499 242.272 193.847 241.669 194.301 241.151C194.756 240.633 195.308 240.209 195.926 239.904C196.544 239.599 197.216 239.419 197.904 239.374L291.062 233.274C297.237 232.87 302.571 237.548 302.976 243.724C303.38 249.9 298.701 255.235 292.526 255.639L199.368 261.738C199.251 261.746 199.135 261.75 199.018 261.75Z",
    fill: "#2751A5"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.992 263.776C215.616 263.774 214.295 263.239 213.304 262.284C212.313 261.33 211.73 260.029 211.677 258.654L211.003 240.644C210.977 239.945 211.089 239.249 211.332 238.593C211.575 237.938 211.945 237.337 212.42 236.825C212.896 236.313 213.468 235.899 214.103 235.608C214.738 235.317 215.425 235.153 216.123 235.127L293.807 232.223C294.505 232.197 295.202 232.309 295.857 232.552C296.512 232.795 297.113 233.165 297.625 233.641C298.138 234.116 298.551 234.688 298.842 235.323C299.134 235.958 299.297 236.645 299.323 237.343L299.996 255.353C300.022 256.051 299.911 256.748 299.667 257.403C299.424 258.058 299.055 258.659 298.579 259.171C298.104 259.683 297.532 260.097 296.897 260.388C296.262 260.68 295.576 260.843 294.877 260.869L217.193 263.772C217.126 263.775 217.059 263.776 216.992 263.776Z",
    fill: "#2F2E41"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.968 427H295.032C293.639 426.998 292.302 426.444 291.317 425.459C290.331 424.473 289.777 423.137 289.775 421.744V322.257C289.776 320.863 290.331 319.527 291.316 318.542C292.302 317.556 293.638 317.002 295.032 317H306.968C308.362 317.002 309.698 317.556 310.684 318.542C311.669 319.527 312.224 320.863 312.225 322.257V421.744C312.223 423.137 311.669 424.473 310.683 425.459C309.698 426.444 308.362 426.998 306.968 427Z",
    fill: "#2F2E41"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.864 375.123L243.555 368.874C242.352 368.143 241.489 366.965 241.154 365.599C240.818 364.232 241.039 362.788 241.767 361.583L293.843 275.666C294.574 274.463 295.752 273.599 297.12 273.263C298.487 272.928 299.931 273.149 301.136 273.877L311.444 280.126C312.647 280.857 313.51 282.035 313.846 283.402C314.181 284.769 313.96 286.213 313.232 287.418L261.155 373.334C260.424 374.537 259.246 375.401 257.879 375.736C256.512 376.071 255.068 375.851 253.864 375.123Z",
    fill: "#2F2E41"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 214C266.05 214 247.5 195.45 247.5 172.5C247.5 149.55 266.05 130.999 289 130.999C311.949 130.999 330.5 149.549 330.5 172.499C330.5 195.449 311.949 213.999 289 213.999V214Z",
    fill: "#2751A5"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.806 186.951C265.476 186.514 264.255 185.797 263.225 184.848C262.542 184.171 262.016 183.353 261.683 182.452C261.35 181.55 261.218 180.586 261.296 179.628C261.34 178.945 261.541 178.282 261.883 177.69C262.225 177.098 262.7 176.593 263.27 176.214C264.747 175.265 266.725 175.263 268.739 176.15L268.663 160.008L270.285 159.999L270.374 178.976L269.126 178.19C267.676 177.28 265.606 176.639 264.145 177.578C263.784 177.826 263.485 178.153 263.271 178.536C263.057 178.918 262.934 179.345 262.912 179.782C262.857 180.496 262.956 181.213 263.204 181.885C263.451 182.557 263.84 183.167 264.345 183.675C266.135 185.385 268.747 185.921 271.726 186.398L271.469 187.999C269.887 187.789 268.326 187.438 266.807 186.95L266.806 186.951Z",
    fill: "#2F2E41"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.164 160.754L251.395 159L260.838 160.247L260.606 162L251.164 160.754Z",
    fill: "#2F2E41"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278 164.261L278.24 162.447L288.001 163.736L287.762 165.549L278 164.26V164.261Z",
    fill: "#2F2E41"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.954 349.999H254.045C252.213 349.997 250.457 349.268 249.162 347.973C247.866 346.678 247.138 344.922 247.136 343.09L261.771 230.857C261.782 229.034 262.515 227.289 263.809 226.003C265.103 224.718 266.853 223.998 268.677 223.999H293.488C314.12 224.023 330.841 240.743 330.864 261.377V343.09C330.862 344.922 330.133 346.678 328.838 347.973C327.542 349.268 325.786 349.997 323.954 349.999Z",
    fill: "#2F2E41"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.934 343.902C305.508 344.833 304.821 345.62 303.958 346.17C303.094 346.719 302.09 347.007 301.066 346.999L289.025 346.896C288.329 346.89 287.641 346.747 287 346.475C286.359 346.203 285.778 345.807 285.289 345.311C284.801 344.814 284.416 344.226 284.155 343.58C283.894 342.935 283.763 342.244 283.769 341.548L284.588 247.226C284.643 240.97 289.755 235.946 296.008 235.999C302.261 236.054 307.286 241.166 307.231 247.419L306.414 341.742C306.408 342.487 306.245 343.223 305.934 343.9V343.902Z",
    fill: "#2751A5"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.229 318.91C310.804 319.838 310.119 320.624 309.258 321.172C308.396 321.72 307.395 322.008 306.374 322L285.865 321.82C284.463 321.806 283.125 321.237 282.142 320.237C281.16 319.238 280.614 317.89 280.624 316.488L281.294 239.242C281.306 237.84 281.875 236.5 282.875 235.517C283.875 234.534 285.224 233.989 286.627 234.001L307.135 234.179C307.829 234.185 308.516 234.328 309.155 234.599C309.795 234.87 310.374 235.265 310.861 235.76C311.348 236.256 311.732 236.842 311.992 237.486C312.253 238.13 312.383 238.819 312.377 239.514L311.707 316.759C311.701 317.502 311.539 318.235 311.229 318.91Z",
    fill: "#2F2E41"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.069 362.198C241.185 361.462 241.456 360.76 241.863 360.136C242.271 359.513 242.806 358.983 243.433 358.581L253.563 352.046C254.747 351.285 256.184 351.024 257.56 351.321C258.936 351.618 260.138 352.449 260.902 353.631L292.152 402.079C292.915 403.262 293.177 404.7 292.88 406.077C292.583 407.453 291.752 408.655 290.569 409.418L280.438 415.951C279.255 416.712 277.817 416.974 276.441 416.677C275.066 416.38 273.864 415.55 273.099 414.368L241.849 365.92C241.135 364.819 240.857 363.492 241.069 362.197V362.198Z",
    fill: "#2F2E41"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.225 47.198C203.456 45.3721 202.169 43.8118 200.522 42.7102C198.875 41.6086 196.942 41.014 194.961 41H10.0334C4.49792 41.002 0.0107936 45.4891 0.00878906 51.0246V284.974C0.0117958 290.51 4.49892 294.997 10.0334 294.999H194.967C200.5 294.992 204.984 290.509 204.992 284.974V51.0236C204.996 49.7104 204.738 48.4097 204.231 47.198H204.225ZM202.759 284.974C202.757 287.042 201.935 289.024 200.473 290.486C199.011 291.948 197.029 292.77 194.962 292.773H10.0324C7.96469 292.773 5.9817 291.951 4.51932 290.49C3.05694 289.028 2.23487 287.045 2.23381 284.977V51.0246C2.23699 48.9574 3.05968 46.9757 4.52154 45.514C5.9834 44.0524 7.96516 43.2299 10.0324 43.227H194.966C196.523 43.2328 198.044 43.7025 199.333 44.5761C200.622 45.4497 201.622 46.6877 202.205 48.1321C202.575 49.0515 202.765 50.0335 202.765 51.0246L202.758 284.974H202.759Z",
    fill: "#3F3D56"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.517 96.4828H109.483C108.294 96.4828 107.153 96.0105 106.313 95.1698C105.472 94.329 105 93.1887 105 91.9997C105 90.8107 105.472 89.6704 106.313 88.8297C107.153 87.9889 108.294 87.5166 109.483 87.5166H165.517C166.706 87.5166 167.847 87.9889 168.687 88.8297C169.528 89.6704 170.001 90.8107 170.001 91.9997C170.001 93.1887 169.528 94.329 168.687 95.1698C167.847 96.0105 166.706 96.4828 165.517 96.4828Z",
    fill: "#3F3D56"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.517 119.982H109.483C108.294 119.982 107.154 119.51 106.313 118.669C105.472 117.828 105 116.688 105 115.499C105 114.31 105.472 113.17 106.313 112.33C107.154 111.489 108.294 111.017 109.483 111.017H165.517C166.706 111.017 167.846 111.489 168.687 112.33C169.528 113.17 170 114.31 170 115.499C170 116.688 169.528 117.828 168.687 118.669C167.846 119.51 166.706 119.982 165.517 119.982Z",
    fill: "#3F3D56"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6815 134H40.3182C38.9676 133.998 37.6729 133.461 36.7179 132.506C35.7629 131.551 35.2257 130.256 35.2241 128.906V80.094C35.2272 77.2842 37.5053 75.004 40.3182 75.001H81.6815C84.4933 75.004 86.7725 77.2832 86.7755 80.096V128.907C86.7739 130.257 86.2367 131.552 85.2817 132.507C84.3268 133.462 83.032 133.998 81.6815 134Z",
    fill: "#2751A5"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.538 167.462H39.4617C38.2781 167.462 37.143 166.992 36.3061 166.155C35.4692 165.318 34.999 164.183 34.999 163C34.999 161.816 35.4692 160.681 36.3061 159.844C37.143 159.007 38.2781 158.537 39.4617 158.537H165.538C166.124 158.537 166.705 158.653 167.246 158.877C167.788 159.101 168.28 159.43 168.694 159.844C169.108 160.259 169.437 160.751 169.661 161.292C169.886 161.833 170.001 162.414 170.001 163C170.001 163.586 169.886 164.166 169.661 164.708C169.437 165.249 169.108 165.741 168.694 166.155C168.28 166.57 167.788 166.898 167.246 167.123C166.705 167.347 166.124 167.462 165.538 167.462Z",
    fill: "#CCCCCC"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.538 191.463H39.4617C38.278 191.463 37.1428 190.993 36.3058 190.156C35.4688 189.319 34.9985 188.184 34.9985 187C34.9985 185.817 35.4688 184.681 36.3058 183.844C37.1428 183.007 38.278 182.537 39.4617 182.537H165.538C166.722 182.537 167.857 183.007 168.694 183.844C169.531 184.681 170.002 185.817 170.002 187C170.002 188.184 169.531 189.319 168.694 190.156C167.857 190.993 166.722 191.463 165.538 191.463Z",
    fill: "#CCCCCC"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.538 214.463H39.4617C38.278 214.463 37.1428 213.993 36.3058 213.156C35.4688 212.319 34.9985 211.184 34.9985 210C34.9985 208.817 35.4688 207.681 36.3058 206.844C37.1428 206.007 38.278 205.537 39.4617 205.537H165.538C166.722 205.537 167.857 206.007 168.694 206.844C169.531 207.681 170.002 208.817 170.002 210C170.002 211.184 169.531 212.319 168.694 213.156C167.857 213.993 166.722 214.463 165.538 214.463Z",
    fill: "#CCCCCC"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.538 237.463H39.4617C38.278 237.463 37.1428 236.993 36.3058 236.156C35.4688 235.319 34.9985 234.184 34.9985 233C34.9985 231.817 35.4688 230.681 36.3058 229.844C37.1428 229.007 38.278 228.537 39.4617 228.537H165.538C166.722 228.537 167.857 229.007 168.694 229.844C169.531 230.681 170.001 231.816 170.001 233C170.001 234.183 169.531 235.318 168.694 236.155C167.857 236.992 166.722 237.462 165.538 237.462V237.463Z",
    fill: "#CCCCCC"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.538 261.463H39.4617C38.278 261.463 37.1428 260.993 36.3058 260.156C35.4688 259.319 34.9985 258.184 34.9985 257C34.9985 255.817 35.4688 254.681 36.3058 253.844C37.1428 253.007 38.278 252.537 39.4617 252.537H165.538C166.125 252.537 166.705 252.653 167.246 252.877C167.788 253.101 168.28 253.43 168.694 253.844C169.109 254.259 169.438 254.751 169.662 255.292C169.886 255.834 170.002 256.414 170.002 257C170.002 257.586 169.886 258.167 169.662 258.708C169.438 259.25 169.109 259.742 168.694 260.156C168.28 260.571 167.788 260.899 167.246 261.124C166.705 261.348 166.125 261.463 165.538 261.463Z",
    fill: "#CCCCCC"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.5 87C181.444 87 162 67.5563 162 43.5C162 19.4437 181.444 0 205.5 0C229.555 0 249 19.4437 249 43.5C249 67.5563 229.555 87 205.5 87Z",
    fill: "#2751A5"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.913 59.999C199.937 60.0007 198.987 59.6848 198.206 59.099L198.157 59.0636L187.961 51.2624C187.007 50.5312 186.382 49.451 186.225 48.2595C186.068 47.0681 186.39 45.8629 187.121 44.9091C187.852 43.9553 188.933 43.331 190.124 43.1736C191.316 43.0162 192.521 43.3386 193.475 44.0698L200.08 49.1358L215.687 28.7726C216.418 27.8194 217.498 27.1955 218.689 27.0381C219.879 26.8807 221.084 27.2027 222.037 27.9333L222.039 27.9343L221.942 28.0698L222.041 27.9343C222.994 28.6663 223.617 29.7462 223.774 30.9371C223.932 32.128 223.61 33.3326 222.88 34.2866L204.522 58.2274C204.097 58.7791 203.551 59.2255 202.926 59.532C202.3 59.8385 201.613 59.997 200.917 59.9949L200.913 59.999Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_711_38668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_711_38668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.206 428.296H184.795C184.584 428.296 184.382 428.212 184.233 428.063C184.084 427.914 184 427.712 184 427.501C184 427.29 184.084 427.088 184.233 426.939C184.382 426.79 184.584 426.706 184.795 426.706H477.206C477.417 426.706 477.619 426.79 477.768 426.939C477.917 427.088 478.001 427.29 478.001 427.501C478.001 427.712 477.917 427.914 477.768 428.063C477.619 428.212 477.417 428.296 477.206 428.296Z",
    fill: "#3F3D56"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 172,
    fill: "white",
    transform: "translate(352 256)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 172,
    fill: "white",
    transform: "translate(352 256)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 154,
    fill: "white",
    transform: "translate(358 274)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 154,
    fill: "white",
    transform: "translate(358 274)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 29,
    fill: "white",
    transform: "translate(193 233)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 29,
    fill: "white",
    transform: "translate(193 233)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 32,
    fill: "white",
    transform: "translate(211 232)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 32,
    fill: "white",
    transform: "translate(211 231.999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 110,
    fill: "white",
    transform: "translate(289 317)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 110,
    fill: "white",
    transform: "translate(289 317)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 103,
    fill: "white",
    transform: "translate(241 273)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 103,
    fill: "white",
    transform: "translate(241 273.001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 83,
    fill: "white",
    transform: "translate(247 131)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 83,
    fill: "white",
    transform: "translate(247 131)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 28,
    fill: "white",
    transform: "translate(261 160)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 28,
    fill: "white",
    transform: "translate(261 160)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    fill: "white",
    transform: "translate(251 159)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    fill: "white",
    transform: "translate(251 159)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    fill: "white",
    transform: "translate(278 162)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    fill: "white",
    transform: "translate(278 161.999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 126,
    fill: "white",
    transform: "translate(247 224)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 126,
    fill: "white",
    transform: "translate(247 224)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 111,
    fill: "white",
    transform: "translate(283 236)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 111,
    fill: "white",
    transform: "translate(283 236)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 88,
    fill: "white",
    transform: "translate(280 234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 88,
    fill: "white",
    transform: "translate(280 234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 66,
    fill: "white",
    transform: "translate(241 351)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 66,
    fill: "white",
    transform: "translate(241 350.999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 254,
    fill: "white",
    transform: "translate(0 41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 254,
    fill: "white",
    transform: "translate(0.000488281 41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 10,
    fill: "white",
    transform: "translate(105 87)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 10,
    fill: "white",
    transform: "translate(105 87)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    fill: "white",
    transform: "translate(105 111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    fill: "white",
    transform: "translate(105 111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 59,
    fill: "white",
    transform: "translate(35 75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 59,
    fill: "white",
    transform: "translate(35 75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 158)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 158)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 182)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 182)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 228)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 228)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 252)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 10,
    fill: "white",
    transform: "translate(35 252)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white",
    transform: "translate(162)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white",
    transform: "translate(162)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 33,
    fill: "white",
    transform: "translate(186 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 33,
    fill: "white",
    transform: "translate(186 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 3,
    fill: "white",
    transform: "translate(184 426)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_711_38668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 3,
    fill: "white",
    transform: "translate(184 426.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttestation);
export default __webpack_public_path__ + "static/media/Attestation.c192e2a1fd0e8c56a3d3d7921c74f1cc.svg";
export { ForwardRef as ReactComponent };